import { createClient } from '@supabase/supabase-js';
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from '../config/auth';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const msalInstance = new PublicClientApplication(msalConfig);

export const supabase = createClient(supabaseUrl, supabaseAnonKey);